import { Component } from '@angular/core';
import { ThemeService } from '../../../shared-services/services/theme.service';

@Component({
    selector: 'app-theme',
    templateUrl: './theme.component.html',
    standalone: false
})
export class ThemeComponent {
    constructor(
        public themeService: ThemeService
    ) { }
}
